"use client"
// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table, CardTitle, FormGroup } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";

const CardPieceTopic = ({
    pageView,
    validation,
    cardNumber,
    contentCardShow,
    runningNo = 0
}) => {
    let cardRef = useRef(null);

    // useEffect(() => {
    //     if(cardRef !== null) {
    //         cardRef.current.checked = contentCardShow;
    //     }
    // }, [cardRef])

    const checkValue = validation?.values[`contentCard${cardNumber}Show`] ?? false

    return (
        <>
            <Col md={6}>
                <Card color="light">
                    <CardBody className="p-1">
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor={`contentTopic${cardNumber}Label`}
                                    className="col-md-12 col-form-label"
                                >
                                    <i className="bx bxs-grid drag-handle" style={{ cursor: "grab" }} /> Topic Text {runningNo}
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentTopic${cardNumber}Label`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`contentTopic${cardNumber}Label`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentTopic${cardNumber}Label`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentTopic${cardNumber}Label`]}
                                        invalid={
                                            validation.touched[`contentTopic${cardNumber}Label`] &&
                                                validation.errors[`contentTopic${cardNumber}Label`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentTopic${cardNumber}Label`] &&
                                        validation.errors[`contentTopic${cardNumber}Label`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentTopic${cardNumber}Label`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor="contentCard1Number"
                                    className="col-md-12 col-form-label"
                                >
                                    Email Reciepient {runningNo}
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentTopic${cardNumber}EmailList`}
                                        className="form-control"
                                        type="text"
                                        placeholder="admin@example.com, admin2@example.com, ..."
                                        name={`contentTopic${cardNumber}EmailList`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentTopic${cardNumber}EmailList`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentTopic${cardNumber}EmailList`]}
                                        invalid={
                                            validation.touched[`contentTopic${cardNumber}EmailList`] &&
                                                validation.errors[`contentTopic${cardNumber}EmailList`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentTopic${cardNumber}EmailList`] &&
                                        validation.errors[`contentTopic${cardNumber}EmailList`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentTopic${cardNumber}EmailList`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>
                        </ul>
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}
export default CardPieceTopic